'use client';

// 创建客户端包装器组件，用于解决SWR全局配置的客户端问题
// 保持架构分离：客户端逻辑被隔离在专门的包装器中
// 避免服务器组件污染：layout.tsx 保持干净，只负责布局
// 明确边界："use client" 指令只在必要时使用

import { SWRConfig } from 'swr';

const fetcher = (url: string) => fetch(url).then(res => res.json());

export default function ClientSWRProvider({
  children
}: {
  children: React.ReactNode
}) {
  return (
    <SWRConfig value={{
      dedupingInterval: 10000,      // 请求去重时间：10秒内重复请求只执行一次
      focusThrottleInterval: 5000,  // 焦点刷新节流：聚焦时请求节流时间：5秒内重复请求只执行一次
      loadingTimeout: 3000,         // 请求超时时间：3秒内请求超时
      errorRetryCount: 3,           // 失败重试次数：3次
      errorRetryInterval: 5000,     // 失败重试间隔：5秒内重复请求只执行一次
      fetcher                       // 默认请求函数：统一fetcher
    }}>
      {children}
    </SWRConfig>
  );
}
